import { CheckOutlined, LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Col, Result, Row } from "antd";
import { AccountLayout } from "components/store-layout/AccountLayout";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { AccountCard } from "toolkit/card/AccountCard";

import "./SuccessPage.less";

export type SuccessPageProps = {
  loading?: boolean,
  type: ResultType,
  title: string,
  subTitle?: string,
  showBack?: boolean,
}

export enum ResultType {
  ERROR,
  SUCCESS
}

function getIcon(type: ResultType) {
  switch (type) {
    case ResultType.ERROR: {
      return (<WarningOutlined className="result-page__warning-icon" />);
    }
    case ResultType.SUCCESS: {
      return (<CheckOutlined className="result-page__check-icon" />);
    }
  }
}

export function ResultPage(props: SuccessPageProps) {
  const { loading, type, title, subTitle, showBack } = props;
  const navigate = useNavigate();
  const intl = useIntl();
  const Icon = getIcon(type);

  return (
    <AccountLayout>
      <AccountCard>
        <Row className="result-page__content" align="middle">
          <Col flex="1 0 300px">
            <Result
              icon={loading ? <LoadingOutlined /> : Icon}
              title={loading ? intl.formatMessage({ id: "jmix-account.result-page.loading" }) : title}
              subTitle={!loading && subTitle}
              extra={!loading && showBack && [
                <Button
                  key="account"
                  type="primary"
                  onClick={() => navigate("/settings/contact-info")}>
                  {intl.formatMessage({ id: "jmix-account.result-page.go-account" })}
                </Button>,
              ]}
            />
          </Col>
        </Row>
      </AccountCard>
    </AccountLayout>
  );
}